define('module/menu',[
    'jquery',
    'underscore',
    'cnf',
    '_pubsub'
], function($,_,Cnf,Pubsub){
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub;
        
        this.options={
            selector:'.burger-menu',
            trigger:'.trigger-menu',
            dataActive:'data-active',
            triggerSubmenu:'.trigger-toggle-submenu',
            parentSubmenu:'.parent'
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initEvent();
            this.initElement();
        };
        
        this.initOptions=function()
        {
            this.active=false;
            this.$menu=$(this.options.selector);
            this.$trigger=$(this.options.trigger);
            this.$triggerSubmenu=$(this.options.triggerSubmenu);
        };
        
        this.initEvent=function()
        {
            oPubsub.on(Pubsub.VIEWPORT_CHANGE,_.bind(this.onViewportChange,this));
        };
        
        this.initElement=function()
        {
            this.$trigger.on(Cnf.click, _.bind(this.toggle,this));
            this.$triggerSubmenu.on(Cnf.click, _.bind(this.toggleSubmenu,this));
        };
        
        this.toggle=function(ev)
        {
            ev.preventDefault();
            ev.stopPropagation();
            
            if(true===this.active) {
                this.close();
            } else {
                this.open();
            }
        };
        
        this.close=function()
        {
            this.active=false;
            this.$menu.attr(this.options.dataActive,'false');
            this.$trigger.attr(this.options.dataActive,'false');
        };
        
        this.open=function()
        {
            this.active=true;
            this.$menu.attr(this.options.dataActive,'true');
            this.$trigger.attr(this.options.dataActive,'true');
        };
        
        this.toggleSubmenu=function(ev)
        {
            var $el=$(ev.currentTarget);
            
            if(true===$el.data('active')) {
                this.closeSubmenu($el);
            } else {
                this.openSubmenu($el);
            }
        };
        
        this.closeSubmenu=function($el)
        {
            $el.data('active', false);
            $el.closest(this.options.parentSubmenu).attr(this.options.dataActive,'false');
        };
        
        this.openSubmenu=function($el)
        {
            $el.data('active', true);
            $el.closest(this.options.parentSubmenu).attr(this.options.dataActive,'true');
        };
        
        /**
         * callback on pubsub viewport change
         * 
         * @param {type} ev
         * @returns {undefined}
         */
        this.onViewportChange=function(ev)
        {
            switch(true) {
                case (ev.current==='desktop')
                    && (true===this.active):
                    this.close();
                    break;
                    
                default:break;
            }
        };
        
        this.init();
    };
    
});

